<div class="row  justify-content-around">
  <div class="col-sm-12">
    <div class="row justify-content-around menu-list">
      <div class="col-sm-3" *ngFor="let item of servicesList">
        <button routerLink="/{{item.routingData}}" [color]="'primary'"
          class="row" mat-raised-button class="button-menu">
          <div class=" row button-content">
            <div class="row">
              <div class="col-sm-4">
                <div class="icon-bg">
                  <mat-icon style="height:100%; width:100%;" svgIcon="{{item.ImageMenuSrc}}"></mat-icon>
                </div>
              </div>
              <div class="col-sm-8">
                <h2>
                  {{item.menuTitle}}
                </h2>
              </div>

            </div>
          </div>
        </button>

      </div>


    </div>
  </div>
